var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "auth-bar-wrapper",
      class: { "is-splash-parent": _vm.isSplash },
    },
    [
      _vm.isLoggedIn
        ? _c(
            "div",
            {
              class: {
                "is-transparent": _vm.isTransparent,
                "is-splash": _vm.isSplash,
                "is-special-mode": _vm.isSpecialMode,
              },
              attrs: { id: "authBarPlaceholder" },
            },
            [
              _c("div", { staticClass: "ab_auth-bar" }, [
                _c("a", {
                  staticClass: "ab_auth-bar__logo",
                  staticStyle: { "background-image": "url('')" },
                  attrs: { href: "/" },
                }),
                _c(
                  "div",
                  {
                    attrs: {
                      id: "ab_auth-bar__auth-button-placeholder",
                      "data-is": "auth-button",
                    },
                  },
                  [
                    _c("div", { staticClass: "ab_auth-button" }, [
                      _c("div", [
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticClass: "ab_user-button ab_clickable",
                              on: {
                                click: function ($event) {
                                  _vm.showUserProfile = !_vm.showUserProfile
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "ab_user-button__image",
                                attrs: {
                                  src: "https://auth-lib.labs.refinitiv.com/assets/avatar.svg",
                                },
                              }),
                              _c(
                                "div",
                                { staticClass: "ab_user-button__name" },
                                [_vm._v(" " + _vm._s(_vm.userName) + " ")]
                              ),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "ab_user-button__arrow",
                              }),
                            ]
                          ),
                          _vm.showUserProfile
                            ? _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "ab_details-popover",
                                    attrs: { id: "ab_details-popover" },
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "ab_details-popover__arrow",
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ab_details-popover__body",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "ab_details-popover__content",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "ab_details-popover__text ab_details-popover__text--large",
                                              },
                                              [_vm._v(_vm._s(_vm.userName))]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "ab_details-popover__text ab_details-popover__text--strong",
                                              },
                                              [_vm._v(_vm._s(_vm.user))]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "ab_details-popover__row",
                                              },
                                              [
                                                _c("img", {
                                                  staticClass:
                                                    "ab_details-popover__logo",
                                                  staticStyle: {
                                                    "background-color":
                                                      "#001EFF",
                                                  },
                                                  attrs: {
                                                    src: "https://auth-lib.labs.refinitiv.com/assets/lseg_avatar.svg",
                                                  },
                                                }),
                                                _vm._m(0),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "ab_button ab_button--sign-out",
                                                    on: {
                                                      click: _vm.handleSignOut,
                                                    },
                                                  },
                                                  [_vm._v("Sign Out")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "logo-container",
          on: {
            click: function ($event) {
              return _vm.goToHome()
            },
          },
        },
        [
          !_vm.isSplash
            ? _c("img", {
                attrs: {
                  src: require("../assets/logo_new.png"),
                  alt: "Refinitiv Labs",
                },
              })
            : _vm._e(),
          _vm.isSplash
            ? _c("img", {
                attrs: {
                  src: require("../assets/logo_new.png"),
                  alt: "Refinitiv Labs",
                },
              })
            : _vm._e(),
          !_vm.isSplash ? _c("div", { staticClass: "logo-line" }) : _vm._e(),
          !_vm.isSplash
            ? _c("span", { staticClass: "logo-text" }, [
                _vm._v(" Trade Discovery "),
                _vm.environment === "preprod"
                  ? _c("div", { staticClass: "logo-superscript" }, [
                      _vm._v("Beta"),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ]
      ),
      _vm.showMaintenance
        ? _c("div", { staticClass: "maintenance-message" }, [
            _c("p", [_vm._v("Application Scheduled Maintenance")]),
            _vm._m(1),
          ])
        : _vm._e(),
      _vm.showNav
        ? _c(
            "i",
            {
              staticClass: "header-burger-icon material-icons",
              on: {
                click: function ($event) {
                  _vm.menuIsExpanded = !_vm.menuIsExpanded
                },
              },
            },
            [_vm._v("menu")]
          )
        : _vm._e(),
      _c(
        "nav",
        {
          staticClass: "nav-header",
          class: {
            "is-active": _vm.menuIsExpanded,
            "signed-out": !_vm.user || _vm.routeName === "splash",
          },
        },
        [
          _vm.showNav
            ? _c(
                "div",
                [
                  _c(
                    "router-link",
                    {
                      class: {
                        "router-link-active": _vm.$route.path === "/results",
                      },
                      attrs: { to: "/calculator" },
                    },
                    [_vm._v(" Risk Factor Calculator ")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", [
      _c("div", { staticClass: "ab_details-popover__text" }, [
        _vm._v("Signed in with"),
      ]),
      _c(
        "div",
        {
          staticClass:
            "ab_details-popover__text ab_details-popover__text--strong",
        },
        [_vm._v("Refinitiv")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _vm._v(
        "All Days – 20:00 to 22:00 HRS UTC & Saturday: 08:00 to 22:00 HRS UTC. Contact Email: "
      ),
      _c("a", { attrs: { href: "mailto:frtb-cloud-app-dev@lseg.com" } }, [
        _vm._v("frtb-cloud-app-dev@lseg.com"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }